import { useMemo } from 'react';
import TranscriptPagingUtil from 'utils/TranscriptPagingUtil';

const useNumberOfPages = (transcriptBody) => {
  const numberOfPages = useMemo(() => {
    if (!transcriptBody || !transcriptBody.length) return 0;
    return TranscriptPagingUtil.getNumberOfPages(transcriptBody.length);
  }, [transcriptBody]);

  return numberOfPages;
};

export default useNumberOfPages;